import styled from 'styled-components'

export const SpinWrapper = styled.div`
  display: flex;
  align-items: center;
`
